import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { getVersion } from '../../utils/getVersion.js';
import { style } from '../../utils/style.js';
import { Badge } from '../Badge/Badge.js';
import { renderTabItemInner } from './renderTabItemInner.js';
const tabPaddingStyleMap = {
    default: 'px-xs',
    underlined: 'px-m',
    animated: 'px-m border border-gray cursor-pointer text-left border-b-0 mt-auto flex gap-2xs',
};
const tabTextStyle = 'text-secondary-text hover:text-primary-main';
const activeTabTextStyleMap = {
    default: 'text-black sm:text-white',
    underlined: 'text-primary-main border-b-2',
    animated: 'text-white sm:text-white',
};
const tabBgStyleMap = {
    default: 'bg-white',
    underlined: 'bg-white',
    animated: 'p-1 ease-in duration-300 bg-white text-primary-text h-[70px] w-96',
};
const activeTabBgStyleMap = {
    default: 'bg-white sm:bg-primary-main',
    underlined: 'bg-white',
    animated: 'p-2 border-none bg-primary-main text-white h-20 w-96',
};
export const TabItemInner = JSX(({ tag = 'div', item = {}, isActive = false, type = 'default', onClick }) => {
    const Tag = tag;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { text, description, icon, count, tabName, ...link } = item;
    return (_jsx(Tag, { className: style('h-12', 'block flex-1', 'cursor-pointer', tabPaddingStyleMap[type], isActive ? activeTabBgStyleMap[type] : tabBgStyleMap[type]), role: "tablist", "aria-label": "\u0421\u043F\u0438\u0441\u043E\u043A \u0442\u0430\u0431\u043E\u0432", onClick: onClick, ...link, children: _jsxs("div", { className: style('h-full', 'flex justify-center items-center', 'text-center whitespace-nowrap', isActive ? activeTabTextStyleMap[type] : tabTextStyle), role: "tab", "aria-label": `Таб ${text}`, children: [renderTabItemInner({
                    text,
                    description,
                    icon,
                    isActive,
                    type,
                }), Number.isInteger(count) ? (_jsx("div", { className: "ml-xs", role: "status", "aria-label": `Количество программ и сервисов ${count}`, children: _jsx(Badge, { count: count, version: getVersion(isActive, type) }) })) : null] }) }));
});
//# sourceMappingURL=TabItemInner.js.map